export const base64ToString = (str: string): string => decodeURIComponent(escape(window.atob(str)));
export const stringToBase64 = (str: string): string => window.btoa(unescape(encodeURIComponent(str)));
